import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ETipoRelatorio } from 'src/app/enums/relatorios/ETipoRelatorio.enum';
import { IRelatorioFranquiaGlobalResponseData } from 'src/app/interfaces/relatorio/FranquiaGlobal/IRelatorioFranquiaGlobalResponseData';
import { RelatorioFranquiaGlobalService } from 'src/app/services/relatorios/franquia-global/relatorio-franquia-global.service';

@Component({
  selector: 'app-relatorio-franquia-global',
  templateUrl: './relatorio-franquia-global.component.html',
  styleUrls: ['./relatorio-franquia-global.component.scss']
})
export class RelatorioFranquiaGlobalComponent {
  private subscriptions$ = new Subscription();
  relatorio: IRelatorioFranquiaGlobalResponseData;
  codigoContrato: string;
  mesAno: string;

  constructor(
    private relatorioFranquiaGlobalService: RelatorioFranquiaGlobalService,
    private route: ActivatedRoute
  ) {}

  getDadosRelatorioFranquiaGlobal() {
    this.subscriptions$.add(
      this.relatorioFranquiaGlobalService
        .postRelatorioFranquiaGlobal({
          codigoContrato: this.codigoContrato,
          mesReferencia: this.mesAno,
          tipoExportacao: ETipoRelatorio.PDF
        })
        .subscribe({
          next: ({ data }) => {
            this.relatorio = data;
          }
        })
    );
  }
  ngOnInit() {
    this.route.params.subscribe(
      (params) => (
        (this.codigoContrato = params['codContrato']),
        (this.mesAno = params['mesAno'])
      )
    );
    this.getDadosRelatorioFranquiaGlobal();
  }
}
